import React from 'react';
import NavBar from './Components/NavBar';
import Footer from './Components/Footer/Footer';
/* The setting component */
import AssetInput from './Components/AssetInput/AssetInput';
import OptimizationApproachDisplay from './Components/OptimizationApproachDisplay/OptimizationApproachDisplasy';
import OptimizationSettingsDisplay from './Components/OptimizationSettingDisplay/OptimizationSettingDisplay';

/* Cascade style component */
import './App.css';

/* Visualization component */
import ResultsColumn from './Components/VisualizationResult/VisualizationResult';
function App() {
    return (
        <div className="app-container">
            <NavBar />
            <div className="sections-container">
                <section>
                    <h2 id="asset-input-heading">Asset Input</h2>
                    <AssetInput />
                </section>
                <section>
                    <h2 id="state-display-heading">Optimization Approach</h2>
                    <OptimizationApproachDisplay />
                </section>
                <section>
                    <h2 id="optimization-setting">Optimization Setting</h2>
                    <OptimizationSettingsDisplay />
                </section>
            </div>
            <ResultsColumn />
            <Footer />
        </div>

    );
}
export default App;
